<section>
  <app-auth-template
    [title]="'Login'"
    [description]="
      'Willkommen zurück! Bitte melde dich mit deinen Zugangsdaten an, um fortzufahren.'
    "
  >
    <form (ngSubmit)="login()">
      <app-input
        type="text"
        [control]="form.controls.email"
        [label]="'Email'"
      />

      <div class="relative">
        <app-password-input
          [control]="form.controls.password"
          [label]="'Passwort'"
        />

        <a
          class="absolute bottom-0 right-0 underline text-sm text-blue"
          [routerLink]="['/reset']"
          >Passwort vergessen?</a
        >
      </div>

      @if (requestState() === RequestStateEnum.ERROR) {
        <app-alert [message]="errorMsg" />
      }

      <app-auth-button
        buttonText="Login"
        hintText="Noch keinen Account?"
        linkText="Sign-Up"
        route="/register"
        type="submit"
        [disabled]="form.invalid || form.disabled"
        [isLoading]="isLoading"
        [showHint]="true"
      />
    </form>
  </app-auth-template>
</section>
